import React from 'react';
import { Box, Button, Typography } from '@material-ui/core';

const Login = ({
  onLineLoginClick,
  onRegisterClick,
}) => (
  <Box display="flex" flexDirection="row" width="100%">
    <Box flexGrow={1} display="flex" justifyContent="center">
      <Typography>快速登入</Typography>
      <Button onClick={onLineLoginClick}>LINE Login</Button>
    </Box>
    <Box flexGrow={1} display="flex" justifyContent="center">
      <Typography>註冊</Typography>
      <Button onClick={onRegisterClick}>開始註冊</Button>
    </Box>
  </Box>
);

export default Login;
